export const STATUS_CONFIG = {
  LIVE: { color: "#10B981", label: "Live" },
  BETA: { color: "#F59E0B", label: "Beta" },
  "BETA / LIVE": { color: "#F59E0B", label: "Live / Beta" },
  "LIVE / BETA": { color: "#F59E0B", label: "Live / Beta" },
  "PRIVATE BETA": { color: "#8B5CF6", label: "Private Beta" },
  "IN DEVELOPMENT": { color: "#3B82F6", label: "In Development" },
  PROTOTYPE: { color: "#EC4899", label: "Prototype" },
  CONCEPT: { color: "#64748B", label: "Concept" },
  "IMJOVE LABS": { color: "#D4AF37", label: "ImJove Labs" },
  "IMJOVE TECHNOLOGY": { color: "#D4AF37", label: "ImJove Technology" },
  "COMING SOON": { color: "#A1A1AA", label: "Coming Soon" },
  RESEARCH: { color: "#0EA5E9", label: "Research" },
  DEVELOPMENT: { color: "#3B82F6", label: "Development" },
};

export function statusMeta(status) {
  return STATUS_CONFIG[status] || { color: "#A1A1AA", label: status || "Unknown" };
}
